// Lead-source attribution (Phase 7)
export const setLeadSource = (source) => {
  try { sessionStorage.setItem('ld_lead_source', source); } catch { /* ignore */ }
};

export const getLeadSource = () => {
  try { return sessionStorage.getItem('ld_lead_source') || ''; } catch { return ''; }
};
